import React, { useCallback, useEffect, useState } from "react"
import OfferBlock from "components/shared/OfferBlock"
import { ProfileOfferService } from "services/api-service"
import { OfferType } from "services/api-service/types"
import { SentryService } from "services/SentryService"
import styled from "styled-components"
import { Box, Row } from "ui/components/atoms/_atoms"
import Spinner from "ui/components/atoms/spinner"

const OffersList = () => {
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [data, setData] = useState<OfferType[]>([])

  const fetchOffers = useCallback(async (newPage: number) => {
    try {
      setLoading(true)
      const { content } = await ProfileOfferService.getOffers(newPage)
      setData(content)
    } catch (e) {
      SentryService.error("[ERROR ProfileOfferService.getOffers]:", e)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchOffers(page)
  }, [fetchOffers, page])

  if (loading)
    return (
      <Wrapper>
        <Row $justifyContent="center">
          <Spinner $size="30px" />
        </Row>
      </Wrapper>
    )

  return (
    <Wrapper>
      {data.map(el => (
        <OfferBlock key={el.id} data={el} />
      ))}
    </Wrapper>
  )
}

export default OffersList

const Wrapper = styled(Box)`
  padding: ${({ theme }) => theme.space.M} 0;
  display: flex;
  flex-direction: column;
  grid-gap: ${({ theme }) => theme.space.XS};
`
